<div class="api-contract-section" *ngIf="api_data_loaded">
  <div class="api-contract-side-nav-section">
    <div class="api-contract-side-nav-logo-section">
      <img src="assets/login.png" class="api-contract-side-nav-logo" />
    </div>
    <div class="api-contract-option-group-section">
      <div class="api-contract-section-heading-section">
        <span class="api-contract-section-heading">API Reference</span>
      </div>
      <div
        class="each-api-contract-group-section"
        *ngFor="let api_group of api_data"
        (click)="selectAPIGroup(api_group)"
      >
        <div class="each-api-contract-group-name">
          <div
            class="each-api-contract-group-name-circle"
            [ngClass]="{
              'each-api-contract-group-name-circle-selected':
                selected_api_group.id != '' &&
                selected_api_group.id == api_group.id
            }"
          ></div>
          <span>{{ api_group.name }}</span>
        </div>
        <ng-container *ngIf="selected_api_group.id == api_group.id">
          <div class="each-api-contract-sub-group">
            <div
              class="each-api-contract-sub-group-section"
              *ngFor="let api of api_group.apis"
              (click)="selectAPI(api_group, api, $event)"
            >
              <div class="each-api-contract-sub-group-name">
                <div
                  class="each-api-contract-sub-group-name-circle"
                  [ngClass]="{
                    'each-api-contract-sub-group-name-circle-selected':
                      selected_api.id != '' && selected_api.id == api.id
                  }"
                ></div>
                <span>{{ api.name }}</span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="api-contract-details">
    <div class="api-contarct-filter-section">
      <span class="api-contarct-filter-label">API Type</span>
      <mat-select
        class="api-contarct-filter"
        [(ngModel)]="selected_api_filter"
        (selectionChange)="getAPIData()"
      >
        <mat-option [value]="'All'">All</mat-option>
        <mat-option [value]="'Internal'">Internal</mat-option>
        <mat-option [value]="'External'">External</mat-option>
      </mat-select>
    </div>
    <div class="api-contract-content-section" id="api-contract-container">
      <ng-container *ngFor="let api_group of api_data">
        <div class="each-api-group-content-section" [attr.id]="api_group.id">
          <div class="each-api-group-content-heading-section">
            <span>{{ api_group.name }}</span>
          </div>
          <p class="each-api-group-heading">Introduction</p>
          <div class="each-api-group-content-description-section">
            <span>{{ api_group.description }}</span>
          </div>
        </div>
        <ng-container *ngFor="let api of api_group.apis">
          <!-- <div class="each-api-sub-group-content-section" [attr.id]="api.id" [ngClass]="{'selcted-section': api.open}"> -->
          <div class="each-api-sub-group-content-section" [attr.id]="api.id">
            <div
              class="each-api-sub-group-meta-section"
              (click)="
                selectAPI(api_group, api, $event); toggleAPISelection(api.id)
              "
            >
              <div class="each-api-sub-group-content-heading-section">
                <div>
                  <span>{{ api.name }}</span>
                  <span class="api-field-name" style="margin-left: 8px">{{
                    api.type
                  }}</span>
                </div>
                <!-- <div class="api-option-section" *ngIf="!api.open"> -->
                <div
                  class="api-option-section"
                  *ngIf="api_expanded_id != api.id"
                >
                  <!-- <img src="assets/back-icon.png" class="api-option-open-icon" /> -->
                  <span class="api-route-url">Expand</span>
                  <img
                    src="assets/api-accordion-open.png"
                    class="api-option-open-icon"
                  />
                </div>
                <!-- <div class="api-option-section" *ngIf="api.open"> -->
                <div
                  class="api-option-section"
                  *ngIf="api_expanded_id == api.id"
                >
                  <!-- <img src="assets/back-icon.png" class="api-option-open-icon" /> -->
                  <span class="api-route-url">Collapse</span>
                  <img
                    src="assets/api-accordion-close.png"
                    class="api-option-close-icon"
                  />
                </div>
              </div>
              <p class="api-version">{{ api.version }}</p>
              <p class="each-api-group-heading">Request Method & Endpoint</p>
              <div class="api-route-information">
                <span class="api-route-type">{{ api.method }}</span>
                <span class="api-route-url">{{ api.request_url }}</span>
              </div>
              <div class="each-api-sub-group-content-description-section">
                <span>{{ api.description }}</span>
              </div>
            </div>
            <!-- <div class="each-api-more-details-section" *ngIf="api.open"> -->
            <div
              class="each-api-more-details-section"
              *ngIf="api_expanded_id == api.id"
            >
              <div class="each-api-information-section">
                <div class="each-api-information-heading-section">
                  <span>Headers</span>
                </div>
                <div
                  class="api-info-details-section"
                  *ngFor="let field of api.headers"
                >
                  <div class="api-info-details-fields-section">
                    <span class="api-field-name">{{
                      field.parameter_name
                    }}</span>
                    <div class="api-field-type-details">
                      <span class="api-field-type">TYPE</span>
                      <span class="api-field-type-name">{{ field.type }}</span>
                    </div>
                  </div>
                  <p class="api-info-details-fields-description">
                    {{ field.description }}
                  </p>
                </div>
                <div
                  class="api-info-details-zero-state"
                  *ngIf="api.headers.length == 0"
                >
                  <span>NOT APPLICABLE</span>
                </div>
              </div>

              <div class="api-details-info-section">
                <div class="each-api-information-section">
                  <div class="each-api-information-heading-section">
                    <span>Path Parameters</span>
                  </div>
                  <div
                    class="api-info-details-section"
                    *ngFor="let field of api.path_params"
                  >
                    <div class="api-info-details-fields-section">
                      <span class="api-field-name">{{
                        field.parameter_name
                      }}</span>
                      <div class="api-field-type-details">
                        <span class="api-field-type">TYPE</span>
                        <span class="api-field-type-name">{{
                          field.type
                        }}</span>
                      </div>
                    </div>
                    <p class="api-info-details-fields-description">
                      {{ field.description }}
                    </p>
                  </div>
                  <div
                    class="api-info-details-zero-state"
                    *ngIf="api.path_params.length == 0"
                  >
                    <span>NOT APPLICABLE</span>
                  </div>
                </div>
              </div>

              <div class="api-details-info-section">
                <div class="each-api-information-section">
                  <div class="each-api-information-heading-section">
                    <span>Query Parameters</span>
                  </div>
                  <div
                    class="api-info-details-section"
                    *ngFor="let field of api.query_params"
                  >
                    <div class="api-info-details-fields-section">
                      <span class="api-field-name">{{
                        field.parameter_name
                      }}</span>
                      <div class="api-field-type-details">
                        <span class="api-field-type">TYPE</span>
                        <span class="api-field-type-name">{{
                          field.type
                        }}</span>
                      </div>
                    </div>
                    <p class="api-info-details-fields-description">
                      {{ field.description }}
                    </p>
                  </div>
                  <div
                    class="api-info-details-zero-state"
                    *ngIf="api.query_params.length == 0"
                  >
                    <span>NOT APPLICABLE</span>
                  </div>
                </div>
              </div>

              <div class="api-details-info-section">
                <div
                  class="each-api-information-section"
                  [ngClass]="{
                    'api-info-code-details-section': api.body_params.length > 0
                  }"
                >
                  <div class="each-api-information-heading-section">
                    <span>Body Parameters</span>
                  </div>
                  <div
                    class="api-info-details-section"
                    *ngFor="let field of api.body_params"
                  >
                    <div class="api-info-details-fields-section">
                      <div>
                        <span class="api-field-name">{{
                          field.parameter_name
                        }}</span>
                        <span class="required-field">{{ field.status }}</span>
                      </div>
                      <div class="api-field-type-details">
                        <span class="api-field-type">TYPE</span>
                        <span class="api-field-type-name">{{
                          field.type
                        }}</span>
                      </div>
                    </div>
                    <p class="api-info-details-fields-description">
                      {{ field.description }}
                    </p>
                  </div>
                  <div
                    class="api-info-details-zero-state"
                    *ngIf="api.body_params.length == 0"
                  >
                    <span>NOT APPLICABLE</span>
                  </div>
                </div>
                <div class="api-info-code-section" *ngIf="api.payload != ''">
                  <div class="api-info-code-header-section">
                    <span>Example Request</span>
                  </div>
                  <p class="code-text" [innerHTML]="getHTML(api.payload)"></p>
                </div>
              </div>

              <div class="api-details-info-section">
                <div
                  class="each-api-information-section api-info-code-details-section"
                >
                  <div class="each-api-information-heading-section">
                    <span>Success Response</span>
                    <p class="each-api-information-secondary-heading">
                      HTTP Status 200
                    </p>
                  </div>
                  <div
                    class="api-info-details-section"
                    *ngFor="let field of api.data_models"
                  >
                    <div class="api-info-details-fields-section">
                      <span class="api-field-name">{{
                        field.parameter_name
                      }}</span>
                      <div class="api-field-type-details">
                        <span class="api-field-type">TYPE</span>
                        <span class="api-field-type-name">{{
                          field.type
                        }}</span>
                      </div>
                    </div>
                    <p class="api-info-details-fields-description">
                      {{ field.description }}
                    </p>
                  </div>
                  <div
                    class="api-info-details-zero-state"
                    *ngIf="api.data_models.length == 0"
                  >
                    <span>NOT APPLICABLE</span>
                  </div>
                </div>
                <div
                  class="api-info-code-section"
                  *ngIf="api.success_response != ''"
                >
                  <div class="api-info-code-header-section">
                    <span>Example Response</span>
                  </div>
                  <p
                    class="code-text"
                    [innerHTML]="getHTML(api.success_response)"
                  ></p>
                </div>
              </div>

              <div class="api-details-info-section">
                <div
                  class="each-api-information-section api-info-code-details-section"
                >
                  <div class="each-api-information-heading-section">
                    <span>Error Response</span>
                  </div>
                  <div
                    class="api-info-details-section"
                    *ngFor="let field of api.error_responses"
                  >
                    <div class="api-info-details-fields-section">
                      <span class="api-field-name">{{ field.name }}</span>
                      <div class="api-field-type-details">
                        <span class="api-field-type">STATUS CODE</span>
                        <span class="api-field-type-name">{{
                          field.code
                        }}</span>
                      </div>
                    </div>
                    <p class="api-info-details-fields-description">
                      {{ field.description }}
                    </p>
                  </div>
                  <div
                    class="api-info-details-zero-state"
                    *ngIf="api.error_responses.length == 0"
                  >
                    <span>NOT APPLICABLE</span>
                  </div>
                </div>
                <div
                  class="api-info-code-section"
                  *ngIf="api.failure_response != ''"
                >
                  <div class="api-info-code-header-section">
                    <span>Example Error Response</span>
                  </div>
                  <p
                    class="code-text"
                    [innerHTML]="getHTML(api.failure_response)"
                  ></p>
                </div>
              </div>

              <div>
                <div class="each-api-information-heading-section">
                  <span>Rate Limiting</span>
                  <p class="each-api-information-secondary-heading">
                    {{ api.rate_limiting }}
                  </p>
                </div>
              </div>

              <div>
                <div class="each-api-information-heading-section no-border">
                  <span>Data Security</span>
                  <p class="each-api-information-secondary-heading">
                    Encryption - Data in transit is encrypted using SSL/TLS.
                    Access is controlled through API tokens.
                  </p>
                </div>

                <div class="each-api-information-heading-section">
                  <p class="each-api-information-secondary-heading">
                    Data At Rest - AWS provides tools to encrypt data at rest
                    using an industry standard AES-256 encryption algorithm.
                  </p>
                </div>
              </div>

              <div>
                <div class="each-api-information-heading-section no-border">
                  <span>CCPA Compliance</span>
                  <p class="each-api-information-secondary-heading">
                    Data Types - {{ api.data_types }}
                  </p>
                </div>

                <div class="each-api-information-heading-section no-border">
                  <p class="each-api-information-secondary-heading">
                    Purpose - {{ api.purpose }}
                  </p>
                </div>

                <div class="each-api-information-heading-section">
                  <p class="each-api-information-secondary-heading">
                    Data Retention - {{ api.data_retention }}
                  </p>
                </div>
              </div>

              <div>
                <div class="each-api-information-heading-section">
                  <span>Changes and Versioning</span>
                  <p class="each-api-information-secondary-heading">
                    This contract may be updated to comply with legal
                    requirements or to reflect new functionalities. All changes
                    will be communicated via email to registered API users.
                  </p>
                </div>
              </div>

              <div>
                <div class="each-api-information-heading-section no-border">
                  <span>Contact Information</span>
                  <p class="each-api-information-secondary-heading">
                    Support Email:
                    <span>
                      <a href="mailto:contact@cognerium.com"
                        >contact@cognerium.com</a
                      >
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<div *ngIf="!api_data_loaded">
  <app-loader [loading_text]="'Loading API Data'"></app-loader>
</div>
